// sendWithRetry.ts — retry an async send with linear backoff (1s, 2s, ...).
// Returns true as soon as one attempt succeeds, false when all attempts fail.
// The caller decides how to surface permanent failure (per CLAUDE.md, loudly).

const defaultSleep = (ms: number) => new Promise<void>((resolve) => setTimeout(resolve, ms));

export async function sendWithRetry(
  send: () => Promise<void>,
  attempts: number,
  onAttemptFailed?: (attempt: number, error: unknown) => void,
  sleep: (ms: number) => Promise<void> = defaultSleep,
): Promise<boolean> {
  for (let attempt = 0; attempt < attempts; attempt++) {
    try {
      if (attempt > 0) {
        await sleep(1000 * attempt);
      }
      await send();
      return true;
    } catch (e) {
      onAttemptFailed?.(attempt + 1, e);
    }
  }
  return false;
}
